module.exports = __webpack_public_path__ + "images/1a04bcd8c18bdd71b4694908b2e091c593ce3812989245288985333e1af25d0b.svg";